import { MouseEventHandler, ReactNode, useState } from 'react';

import { Icon, Types } from '@scale/scaleui';
import { copyToClipboard } from '@scale/frontend-lib/clipboard';

type WithCopyProps = {
  children?: ReactNode;
  className?: string;
  /** Text to be copied to clipboard on click */
  copyText: string;
  /** Size of button */
  size?: Types.Size;
  copyRaw?: boolean;
};

/**
 * Copy icon button that copies text to the clipboard on click. Does a cool transition to a green checkmark too.
 * Child elements appear to the left of the button.
 */
const WithCopy = ({ children, className, copyText, copyRaw }: WithCopyProps) => {
  const [isClicked, setIsClicked] = useState<boolean>(false);
  const onClick: MouseEventHandler = () => {
    setIsClicked(true);
    copyToClipboard(copyText, { excludeOuterQuotes: true, copyRaw });
  };

  // I can't get the icon to switch back to copy when you use tab to focus on
  // it, press enter, then tab away. The icon switch only works when you click.
  return (
    <div className={className}>
      <div className="flex items-center">
        {children}
        <div onMouseLeave={() => setIsClicked(false)}>
          <Icon
            icon={['fas', isClicked ? 'check' : 'copy']}
            onClick={onClick}
            size="sm"
            tooltip="Copy to clipboard"
            variant={isClicked ? 'success' : 'neutral'}
          />
        </div>
      </div>
    </div>
  );
};

export default WithCopy;
